import { NgModule } from '@angular/core';

import { NumberZeroIfNegativePipe } from './number-zero-if-negative.pipe';

@NgModule({
  declarations: [NumberZeroIfNegativePipe],
  exports: [NumberZeroIfNegativePipe],
})
export class NumberPipesModule {}
